import { FileDao } from './file.dao';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataFiles } from '@shared/data-access/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private readonly fileDao = inject(FileDao);

  /**
   * @description
   * Gets a data file by name and type
   */
  public getDataFileByType$<T = unknown>(
    fileName: string,
    fileType: keyof DataFiles,
    retries?: number,
  ): Observable<T> {
    return this.fileDao.getDataFileByType$<T>(fileName, fileType, retries);
  }
}
